/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BilletOrderFeeResponseViewModel } from "../types/BilletOrderFeeResponseViewModel.ts";

export const billetOrderFeeResponseViewModelSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  value: z.number().nullish(),
}) as unknown as ToZod<BilletOrderFeeResponseViewModel>;
